
<div v-if="headerIsDropdown" class="dropdown">
  <button
    type="button"
    :class="classes"
    class="dropdown-toggle btn-table-header"
    data-toggle="dropdown"
    :aria-sort="aria"
    aria-haspopup="true"
    aria-expanded="false"
    style="text-transform: uppercase"
  >
    <slot></slot>
  </button>
  <ul aria-expanded="false" class="dropdown-menu" x-placement="bottom-start">
    <li v-for="(sortOption, index) in dropdownSortOptions" :key="index">
      <button type="button" @click.prevent="$emit('click', sortOption)" :class="sortDropdownItemClasses(sortOption)" aria-selected="false">
        <span class="sr-only">{{ sortOption.direction === "asc" ? "Ascending" : "Descending" }}</span>
        <span aria-hidden="true" :class="sortOption.direction === 'asc' ? 'icon up' : 'icon down'"></span>
        {{sortOption.displayName}}
      </button>
    </li>
  </ul>
</div>

<button v-else
        type="button"
        @click.prevent="$emit('click', value)"
        :class="classes"
        class="btn-table-header"
        :aria-sort="aria">
  <slot></slot>
</button>
